import { fireEventAddToWishList } from '@global/gtm/base';

class WishListGTM {
  static getClickItemInfo(itemInfo) {
    const { id, name, sellPrice, color, size } = itemInfo;
    const hasCategory = window.ItemCategories || undefined;
    const newStringID = String(id).replace('SZ_', '');

    const item = {
      affiliation: color,
      index: 0,
      item_brand: size,
      item_category: hasCategory && hasCategory[0] ? hasCategory[0] : '',
      item_category2: hasCategory && hasCategory[1] ? hasCategory[1] : '',
      item_category3: hasCategory && hasCategory[2] ? hasCategory[2] : '',
      item_category4: hasCategory && hasCategory[3] ? hasCategory[3] : '',
      item_category5: hasCategory && hasCategory[4] ? hasCategory[4] : '',
      item_id: newStringID,
      item_name: name,
      item_variant: '',
      price: sellPrice,
      quantity: 1,
    };

    return item;
  }
}

/**
 * @param {string} payload.href 商品連結
 * @param {string} payload.name 商品名稱
 * @param {number} payload.sellPrice 商品價格
 * @param {number} payload.color 商品顏色
 * @param {number} payload.size 商品尺寸
 */
export default function fireWishlistEvent(payload) {
  window.dataLayer = window.dataLayer || [];

  const ga4Parameters = WishListGTM.getClickItemInfo(payload);

  fireEventAddToWishList({
    value: ga4Parameters.price,
    items: [ga4Parameters],
  });
}
